import { jsx as _jsx } from "react/jsx-runtime";
export const SvgSelect = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm4 4 4.5 15.5 3-5 6 6 3-3-6-6 5-3z' }) }));
//# sourceMappingURL=select.js.map